import { render, staticRenderFns } from "./kucunxq.vue?vue&type=template&id=a0a19b28&scoped=true&"
import script from "./kucunxq.vue?vue&type=script&lang=js&"
export * from "./kucunxq.vue?vue&type=script&lang=js&"
import style0 from "./kucunxq.vue?vue&type=style&index=0&id=a0a19b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a19b28",
  null
  
)

export default component.exports